export const technologyStacks = [
  {
    title: '开发工具',
    desp: 'Visual Studio Code'
  },

  {
    title: '编程语言',
    desp: 'TypeScript 4.x + JavaScript'
  },

  {
    title: '构建工具',
    desp: 'Vite 2.x / Webpack5.x'
  },

  {
    title: '前端框架',
    desp: 'Vue 3.x'
  },

  {
    title: '路由工具',
    desp: 'Vue Router 4.x'
  },

  {
    title: '状态管理',
    desp: 'Vuex 4.x'
  },

  {
    title: 'UI 框架',
    desp: 'Element Plus'
  },

  {
    title: '可视化',
    desp: 'Echart5.x'
  },

  {
    title: '富文本',
    desp: 'WangEditor'
  },

  {
    title: '工具库',
    desp: ' @vueuse/core + dayjs + countup.js'
  },

  {
    title: 'CSS 预编译',
    desp: 'Sass / Less'
  },

  {
    title: 'HTTP 工具',
    desp: 'Axios'
  },

  {
    title: 'Git Hook 工具',
    desp: 'husky'
  },

  {
    title: '代码规范',
    desp: 'EditorConfig + Prettier + ESLint'
  },

  {
    title: '提交规范',
    desp: 'Commitizen + Commitlint'
  },

  {
    title: '自动部署',
    desp: 'Centos + Jenkins + Nginx'
  }
]
